export default __webpack_public_path__ + "static/media/create-account.1d7d544d.jpg";